import { Col, Row, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import { useEffect, useState } from "react";
import { formatNumber, formatPower } from "../../../utils/NumberUtils";
import Spinner from "../../../commons/Spinner";

const TablePvPc50 = ({ selected, setSelected, deviceArr, deviceId }) => {
    const [pcsData, setPcsData] = useState(null);
    const authToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setPcsData(null);
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async (signal) => {
            setIsLoading(true);
            const data = await getElectricityInfo(authToken, deviceId, selected, signal);
            if (!data || data === null) {
                setPcsData({
                    ac_curr_phs_l1: "---",
                    ac_curr_phs_l2: "---",
                    ac_curr_phs_l3: "---",
                    ac_volt_phs_l1: "---",
                    ac_volt_phs_l2: "---",
                    ac_volt_phs_l3: "---",
                    dc_curr_str1: "---",
                    dc_curr_str2: "---",
                    dc_curr_str3: "---",
                    dc_curr_str4: "---",
                    dc_curr_str5: "---",
                    dc_curr_str6: "---",
                    dc_volt_mppt1: "---",
                    dc_volt_mppt2: "---",
                    dc_volt_mppt3: "---",
                    dc_volt_mppt4: "---",
                    dc_volt_mppt5: "---",
                    dc_volt_mppt6: "---",
                    device_id: selected.device_id,
                    event_code: "---",
                    freq: "---",
                    measured_time: "---",
                    power_factor: "---",
                    power_gene_str: "---",
                    time: "---",
                    work_status: "---",
                    status_code: "---",
                    real_power: "---"
                })
            } else {
                setPcsData(data);
            } setIsLoading(false);
        };
        const interval = setInterval(() => {
            fetchData(signal);
        }, 60000);
        fetchData(signal);
        return () => {
            clearInterval(interval);
            controller.abort();
        };
        //eslint-disable-next-line
    }, [selected]);

    return (
        <>
            {isLoading ? <Spinner /> : <Row >
                <Col md={2} lg={2} sm={2} xl={1} className="col-2 d-flex flex-row justify-content-end arrow-menu h-100">
                    <div>
                        <button
                            className="btn_back"
                            onClick={() => setSelected(null)}
                        >
                            <img src="/img/left.png" alt="leftArrow" className="m-2" />
                        </button>
                    </div>
                    <div className="vl">

                    </div>
                </Col>
                <Col md={10} lg={10} sm={10} xl={11} className="col-9">
                    <Row className="d-flex flex-row mx-1">
                        <div className="dropDown">
                            <select
                                type="select"
                                size="sm"
                                className="btn__dropdown"
                                value={selected.device_id}
                                onChange={(e) => setSelected(deviceArr.filter(el => (el.device_id === e.target.value))[0])}
                            >
                                {(deviceArr.length > 0) && deviceArr.map((el, i) => <option value={el.device_id} key={i} > {el.device_id} </option>)}
                            </select>
                        </div>
                        <div className="batteryBox">
                            <div className="colBorder">
                                <Row className="justify-content-center"><img src="/img/pcsImage.png" alt="pv-pcs" className="pv-pcs py-1" />
                                </Row>
                                <Row className="mb-4 mt-4 justify-content-center">
                                    {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>}
                                </Row>
                            </div>
                        </div>
                        <Col md={8} sm={10} lg={7} className="individual-battery">
                            <div className="scroll-bar">
                                {(pcsData !== null) && <Table className="power__data">
                                    <tbody>
                                        <tr>
                                            <td>累計発電量</td>
                                            <td>{formatPower(pcsData.power_gene_str, 2)}h</td>
                                        </tr>
                                        <tr>
                                            <td>有効電力</td>
                                            <td>{formatPower(pcsData.real_power, 2)}</td>
                                        </tr>
                                        <tr>
                                            <td>力率</td>
                                            <td>{formatNumber(pcsData.power_factor, 3)}</td>
                                        </tr>
                                        <tr>
                                            <td>周波数 </td>
                                            <td>{formatNumber(pcsData.freq, 2)}Hz</td>
                                        </tr>
                                        <tr>
                                            <td>DC電圧A</td>
                                            <td>{formatNumber(pcsData.dc_volt_mppt1, 2)}V</td>
                                        </tr>
                                        <tr>
                                            <td>DC電圧B</td>
                                            <td>{formatNumber(pcsData.dc_volt_mppt2, 2)}V</td>
                                        </tr>
                                        <tr>
                                            <td>DC電圧C</td>
                                            <td>{formatNumber(pcsData.dc_volt_mppt3, 2)}V</td>
                                            {/* <td>入力DC電流（ストリング3-2)</td>
                                <td>{pcsData.dc_curr_str3_2}A</td> */}
                                        </tr>
                                        <tr>
                                            <td>DC電圧D</td>
                                            <td>{formatNumber(pcsData.dc_volt_mppt4, 2)}V</td>
                                            {/* <td>入力DC電流（ストリング4-2)</td>
                                <td>{pcsData.dc_curr_str4_2}A</td> */}
                                        </tr>
                                        <tr>
                                            <td>DC電圧E</td>
                                            <td>{formatNumber(pcsData.dc_volt_mppt5, 2)}V</td>
                                            {/* <td>入力DC電流（ストリング5-2)</td>
                                <td>{pcsData.dc_curr_str5_2}A</td> */}
                                        </tr>
                                        <tr>
                                            <td>DC電圧F</td>
                                            <td>{formatNumber(pcsData.dc_volt_mppt6, 2)}V</td>
                                            {/* <td>入力DC電流（ストリング6-2)</td>
                                <td>{pcsData.dc_curr_str6_2}A</td> */}
                                        </tr>
                                        <tr>
                                            <td>DC電流A</td>
                                            <td>{formatNumber(pcsData.dc_curr_str1, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>DC電流B</td>
                                            <td>{formatNumber(pcsData.dc_curr_str2, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>DC電流C</td>
                                            <td>{formatNumber(pcsData.dc_curr_str3, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>DC電流D</td>
                                            <td>{formatNumber(pcsData.dc_curr_str4, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>DC電流E</td>
                                            <td>{formatNumber(pcsData.dc_curr_str5, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>DC電流F</td>
                                            <td>{formatNumber(pcsData.dc_curr_str6, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>系統電圧（A相）</td>
                                            <td>{formatNumber(pcsData.ac_volt_phs_l1, 2)}V</td>
                                        </tr>
                                        <tr>

                                            <td>系統電圧（B相）</td>
                                            <td>{formatNumber(pcsData.ac_volt_phs_l2, 2)}V</td>
                                        </tr>
                                        <tr>
                                            <td>系統電圧（C相）</td>
                                            <td>{formatNumber(pcsData.ac_volt_phs_l3, 2)}V</td>
                                        </tr>
                                        <tr>
                                            <td>系統電流（A相）</td>
                                            <td>{formatNumber(pcsData.ac_curr_phs_l1, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>系統電流（B相）</td>
                                            <td>{formatNumber(pcsData.ac_curr_phs_l2, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>系統電流（C相）</td>
                                            <td>{formatNumber(pcsData.ac_curr_phs_l3, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>PCS状態</td>
                                            <td>{pcsData.status_code}</td>
                                        </tr>
                                        <tr>
                                            <td>イベントコード	</td>
                                            <td>{pcsData.event_code}</td>
                                        </tr>
                                        {/* <tr>
                                            <td>通信エラー</td>
                                            <td>{pcsData.work_status}</td>
                                        </tr> */}
                                    </tbody>
                                </Table>}
                            </div>
                        </Col>

                    </Row>
                </Col>
            </Row>
            }</>
    );
};

export default TablePvPc50;
